import { render, staticRenderFns } from "./sehr-viel-viele.vue?vue&type=template&id=679a4d30&scoped=true"
import script from "./sehr-viel-viele.vue?vue&type=script&lang=js"
export * from "./sehr-viel-viele.vue?vue&type=script&lang=js"
import style0 from "./sehr-viel-viele.vue?vue&type=style&index=0&id=679a4d30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679a4d30",
  null
  
)

export default component.exports